import { Action } from '@ngrx/store';

import { FetchFromLocalStorage } from '@digihaven/shared';

import { FunctionalityAction, FunctionalityActionTypes } from '@actions/functionality.action';

import { FunctionalityState } from 'state';

const emptyState: FunctionalityState = {
    functionalities: {
        downloadDossier: false,
        acceptDossier: false,
        adminFunctions: false,
        createDossier: false,
        createReport: false,
        destroyAndPreserveDossier: false,
        editDossier: false,
        exportDossier: false,
        generalManagement: false,
        interruptDossier: false,
        manageGroupsDossier: false,
        viewDossier: false,
        viewUnpublishedDossier: false,
        editRelations: false,
        viewReports: false,
        viewOrphanedDocument: false,
        viewEvents: false,
        editAdministrativeDataInArchive: false,
        adminOrganisation: false,
        readOrganisation: false,
        adminSecurity: false,
        adminGroups: false
    }
};

export const initialState: FunctionalityState = FetchFromLocalStorage('functionality') || emptyState;

export function reducer(state = initialState, action: Action): FunctionalityState {
    const specificAction: FunctionalityAction = action as FunctionalityAction;
    switch (specificAction.type) {
        case FunctionalityActionTypes.SetFunctionalities:
            return { ...state, functionalities: specificAction.payload };

        case FunctionalityActionTypes.UnsetFunctionalities:
            return { ...emptyState };

        default:
            return state;
    }
}
